import { NavLink } from "react-router";

// Pool, Pipeline (overview), and Outreach-flow tabs were retired in #2220 once
// the DEFINE/RUN surfaces carried that navigation. Overview is now a slim
// artefact-dashboard landing and leads the bar.
const TABS = [
  { to: "overview", label: "Overview" },
  { to: "define", label: "Define" },
  { to: "run", label: "Deliver" },
  { to: "activity", label: "Activity" },
  { to: "lineage", label: "Lineage" },
  { to: "team", label: "Team" },
  { to: "settings", label: "Settings" },
];

export function CampaignTabs() {
  return (
    <nav className="mt-6 flex gap-1 border-b border-border" aria-label="Campaign sections">
      {TABS.map(({ to, label }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) =>
            `-mb-px border-b-2 px-4 py-2 text-sm font-medium transition-colors ${
              isActive
                ? "border-accent text-accent"
                : "border-transparent text-text-muted hover:border-border-strong hover:text-text-secondary"
            }`
          }
          end={false}
        >
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
